module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f073da_banner_800x600.4664d2d3.png";